import React, { useState, useEffect } from "react";
import { X } from "lucide-react";

const STORAGE_KEY = "r6r:shortcuts-notice-dismissed:v1";

/**
 * Small desktop-only notice listing keyboard shortcuts.
 * Hidden on small screens (no physical keyboard) and remembers when the user
 * dismisses it via the X button.
 */
export const ShortcutsNotice = () => {
  const [dismissed, setDismissed] = useState(true); // start true to avoid SSR flash

  useEffect(() => {
    try {
      const stored = window.localStorage.getItem(STORAGE_KEY);
      setDismissed(stored === "1");
    } catch {
      setDismissed(false);
    }
  }, []);

  const dismiss = () => {
    setDismissed(true);
    try {
      window.localStorage.setItem(STORAGE_KEY, "1");
    } catch {
      /* storage disabled */
    }
  };

  if (dismissed) return null;

  return (
    <div
      data-testid="shortcuts-notice"
      className="hidden lg:flex items-start gap-4 border border-neutral-800 bg-neutral-950/70 px-4 py-3 relative"
    >
      <div className="flex-1 flex flex-wrap items-center gap-x-5 gap-y-1.5">
        <span
          className="text-[10px] tracking-[0.3em] uppercase font-bold text-[#FFC800]"
          style={{ fontFamily: '"JetBrains Mono", monospace' }}
        >
          Shortcuts
        </span>
        {[
          { key: "A", label: "Attacker" },
          { key: "D", label: "Defender" },
          { key: "R", label: "Re-roll" },
        ].map((s) => (
          <span
            key={s.key}
            className="flex items-center gap-2 text-[11px] text-neutral-300"
            style={{ fontFamily: '"JetBrains Mono", monospace' }}
          >
            <kbd
              className="inline-flex items-center justify-center font-bold border border-neutral-600 bg-neutral-900 text-white"
              style={{
                minWidth: 22,
                height: 22,
                padding: "0 6px",
                borderRadius: 3,
                fontFamily: '"JetBrains Mono", monospace',
                fontSize: 11,
                boxShadow: "0 1px 0 #000",
              }}
            >
              {s.key}
            </kbd>
            <span className="tracking-wider uppercase">{s.label}</span>
          </span>
        ))}
      </div>
      <button
        type="button"
        onClick={dismiss}
        aria-label="Dismiss shortcuts notice"
        data-testid="shortcuts-notice-dismiss"
        className="absolute top-1.5 right-1.5 text-neutral-500 hover:text-white transition-colors p-1"
      >
        <X size={14} />
      </button>
    </div>
  );
};

export default ShortcutsNotice;
